module.exports = __webpack_public_path__ + "img/344.06f8964a.png";